import { Component, ChangeDetectionStrategy } from '@angular/core';
import {Dialog} from '../../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../../interfaces/dialog/dialog-params';
import {Partner} from '../../../../../../models/partner/partner';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {DialogService} from '../../../../../../services/dialog/dialog.service';
import {SnackbarService} from '../../../../../../services/snackbar/snackbar.service';
import {PartnerBlockRule} from '../../../../../../models/partner/partner-block-rule';
import {PartnerBlockRuleService} from '../../../../../../services/partner/partner-block-rule.service';


@Component({
  selector: 'app-block-rule-form',
  imports: [
    ReactiveFormsModule
],
  templateUrl: './block-rule-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './block-rule-form.component.scss'
})
export class BlockRuleFormComponent implements Dialog {

  partner: Partner | null = null;
  blockRule: PartnerBlockRule | null = null;

  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.maxLength(64)]),
    blockTraffic: new FormControl(true),
    subid: new FormControl('', [Validators.maxLength(32)]),
    redirectUrl: new FormControl('', [Validators.maxLength(255)]),
  });

  constructor(
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private blockRuleService: PartnerBlockRuleService
  ) {
  }

  onDialogInit(params: DialogParams): void {
    this.partner = params.data.partner;
    this.blockRule = params.data.blockRule;

    if (this.blockRule) {
      this.form.patchValue({
        name: this.blockRule.name,
        blockTraffic: this.blockRule.blockTraffic,
        subid: this.blockRule.subid,
        redirectUrl: this.blockRule.redirectUrl,
      });
    }
  }

  invalid(): boolean {
    return this.form.invalid || (!this.form.value.blockTraffic && !this.form.value.redirectUrl);
  }

  submit(): void {
    const data: any = this.form.value;
    if (data.blockTraffic) {
      data.redirectUrl = null;
    }
    if (!data.subid) {
      data.subid = null;
    }

    if (this.blockRule?.id) {
      this.blockRuleService.update(this.blockRule.id, data).subscribe(() => {
        this.snackbar.success('Partner block rule created.');
        this.dialog.closeDialog(true);
      });
    } else {
      if (this.partner?.id) {
        data['partnerId'] = this.partner.id;
      }

      this.blockRuleService.create(data).subscribe(() => {
        this.snackbar.success('Partner block rule created.');
        this.dialog.closeDialog(true);
      });
    }
  }

}
